import { types } from 'mobx-state-tree';

export const HelpCenterItem = types.model('HelpCenterItem', {
  id: types.identifierNumber,
  title: types.string,
  description: types.maybeNull(types.string),
  url: types.maybeNull(types.string),
});

export const HelpCenterCategory = types.model('HelpCenterCategory', {
  id: types.identifierNumber,
  title: types.string,
  description: types.maybeNull(types.string),
  items: types.array(HelpCenterItem),
});
